import RestService from '../services/rest';

async function finalize(
  clientId, cartId, price, type, card, document, location, clientNumber, freight, punchoutUserId = null, observation,
  saveCard = false, paymentInfos = {}, userData = {}, cartProducts = {}, minimumBillingDate = null,
  purchaseFeedback = {}, managerEmail = null, punchoutScope,
) {
  const punchoutUrl = punchoutUserId ? `&punchout=${punchoutUserId}` : '';
  const userUrl = cartId ? `&cart=${cartId}` : '';
  return RestService.postAuthenticated(`purchases/finalize?client=${clientId}${userUrl}${punchoutUrl}`, {
    price,
    type,
    card,
    document,
    location,
    clientNumber,
    freight,
    observation,
    saveCard,
    paymentInfos,
    userData,
    cartProducts,
    minimumBillingDate,
    purchaseFeedback,
    managerEmail,
    punchoutScope,
  });
}

async function estimate(
  clientId, cartId, punchoutUserId = null, price = null, purchaseFeedback = {}, punchoutUserIndicator = null,
  punchoutScope,
) {
  const punchoutUrl = punchoutUserId ? `&punchout=${punchoutUserId}` : '';
  const userUrl = cartId ? `&cart=${cartId}` : '';
  return RestService.postAuthenticated(`purchases/estimate?client=${clientId}${userUrl}${punchoutUrl}`, {
    price,
    purchaseFeedback,
    punchoutUserIndicator,
    punchoutScope,
  });
}

async function initPagSeguroProcess() {
  return RestService.getAuthenticated('pagseguro/initPaymentProcess');
}

async function getPagSeguroSessionId() {
  return RestService.getAuthenticated('pagseguro/getSessionId');
}

async function saveCXML(id, clientId, cxml) {
  return RestService.postAuthenticated(`purchases/savecxml?client=${clientId}`, {
    id,
    cxml,
  });
}

export default {
  finalize,
  estimate,
  initPagSeguroProcess,
  getPagSeguroSessionId,
  saveCXML,
};
